import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ExpensesAdd from "../pages/expenses/ExpenseAdd";
import ExpensesList from "../pages/expenses/ExpensesList";
import ExpensesSettings from "../pages/expenses/ExpensesSettings";
import PaySalary from "../pages/expenses/PaySalary";

export default function ExpensesRoutes() {
  return (
    <Routes>
      <Route path="" element={<Navigate to="/expenses/list" replace />} />
      <Route path="/add" element={<ExpensesAdd />} />
      <Route path="/list" element={<ExpensesList />} />
      <Route path="/settings" element={<ExpensesSettings />} />
      <Route path="/paySalary" element={<PaySalary />} />
    </Routes>
  );
}
